<div class="widget-header_wrapper">
  @if (widget.widgetDescription.hasGroupingSupport && !isGroupLinkingDisabled) {
    <div class="widget-header_linking-group"
      tooltipL10n="components.widgets.common.widget_header_tooltip_group_linking">
      <widget-linking-group-picker
        [targetElementForDropdownMenu]="widgetHeaderElementRef"
        [widgetLinkingGroupId]="widget.linkingGroupId"
        (widgetLinkingGroupIdChange)="widget.setLinkingGroup($event)">
      </widget-linking-group-picker>
    </div>
  }
  <div class="widget-header_title" textHiding [class.-with-linking-group]="widget.widgetDescription.hasGroupingSupport && !isGroupLinkingDisabled">
    <widget-header-title [widget]="widget"></widget-header-title>
  </div>

  <div class="widget-header_controls">
    <svg class="widget-header_controls_icon -remove"
      tooltipL10n="components.widgets.common.widget_header_tooltip_close"
      (click)="onRemoveWidgetClick($event)">
      <use xlink:href="#close"></use>
    </svg>
    <svg class="widget-header_controls_icon -settings"
      tooltipL10n="components.widgets.common.widget_header_tooltip_settings"
      (click)="onOpenSettingsClick($event)">
      <use xlink:href="#settings"></use>
    </svg>
    <svg class="widget-header_controls_icon -detach"
      tooltipL10n="components.widgets.common.widget_header_tooltip_detach"
      (click)="onDetachClick($event)">
      <use xlink:href="#detach"></use>
    </svg>
  </div>
</div>
